import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    TablePagination,
    Box
} from '@mui/material';

interface ReportTableProps {
    data: any[];
    totalCount: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: unknown, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const formatHeader = (key: string) => {
    if (key === 'Checklist'|| key==='ChecklistType') return 'CHECKLIST TYPE';
    // if (key === 'BrokerName') return 'BROKER NAME';
    // if (key === 'JobId') return 'JOB ID';
    return key
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .toUpperCase()
        .trim();
};

const ReportTable: React.FC<ReportTableProps> = ({
    data,
    totalCount,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange
}) => {
    if (!data || data.length === 0) {
        return <div style={{ padding: '1rem' }}> </div>;
    }

    const columns = Object.keys(data[0]).filter(key => key.toLowerCase() !== 'order');

    return (
        <>
            <Paper
                sx={{
                    width: '100%',
                    mb: 2,
                    overflow: 'hidden',
                    border: '0.5px solid #7a6e6e54'
                }}
            >
                <Box sx={{ maxHeight: 400,width:'100%', overflowX: 'auto', }}>
                    <TableContainer sx={{ minWidth: 'max-content' }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                               <TableRow>
                                    <TableCell
                                        sx={{
                                            fontSize: '12px',
                                            width: 60,
                                            fontWeight: 'bold',
                                            textAlign:"center"
                                        }}
                                    >
                                        S.No
                                    </TableCell>
                                    {columns.map((key) => {
                                            return (
                                                <TableCell
                                                    key={key}
                                                    sx={{
                                                        fontSize: '12px',
                                                        width:200,
                                                        fontWeight: 'bold',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {formatHeader(key)}
                                                </TableCell>
                                            )
                                    })}
                                </TableRow>
                            </TableHead>
                        </Table>
                        <Box sx={{ maxHeight: 290, overflowY: 'scroll', overflowX: 'auto',scrollbarWidth: 'none', '&::-webkit-scrollbar': {display: 'none'}, }}>
                            <Table size="small">
                                <TableBody>
                                    {data.map((row, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                                                '&:hover': { backgroundColor: '#f1f1f1' }
                                            }}
                                        >
                                            <TableCell
                                                sx={{
                                                    fontSize: '12px',
                                                    width: 60,
                                                    verticalAlign: 'top',
                                                    textAlign:'center'
                                                }}
                                            >
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>

                                            {columns.map((key, index) => {
                                                return (
                                                    <TableCell
                                                        key={key}
                                                        sx={{
                                                            fontSize: '12px',
                                                            width: 210,
                                                            textAlign: 'center',
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word',
                                                            lineHeight: 1.5,
                                                            verticalAlign: 'top'
                                                        }}
                                                    >
                                                        {row[key]?.toString()}
                                                    </TableCell>
                                                );
                                             })}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </TableContainer>
                </Box>

                <TablePagination
                    rowsPerPageOptions={[100, 200, 350, 500, 1000]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                    labelRowsPerPage="Rows per page"
                    sx={{
                        fontSize: '12px',
                        '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                            fontSize: '12px'
                        }
                    }}
                />
            </Paper>
        </>
    );
};

export default ReportTable;
